import styles from "./style.module.scss";
import RefreshIcon from "@/assets/icons/refreshError.svg";
import Button from "@mui/material/Button";
import { t } from "i18next";

interface RefreshErrorPageProps {
    open?: boolean;
    text?: string;
    buttonText?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
    style?: any; // 外层自定义样式
    btnSx?: any; // 按钮自定义样式
}
const RefreshErrorPage = ({
    icon = <RefreshIcon />,
    text = t('common.pageStatus.error'),
    buttonText = t("cart.page.refresh"),
    onClick,
    style,
    btnSx,
}: RefreshErrorPageProps) => {
    return (
        <div className={styles.refreshErrorPage} style={style}>
            <div className={styles.refreshErrorPageContent}>
                {icon}
                <span>{text}</span>
                <Button
                    variant="contained"
                    disableElevation
                    onClick={onClick}
                    sx={{
                        width: "65px",
                        height: "28px",
                        fontSize: "12px",
                        margin: "8px 0",
                        backgroundColor: "#fff", // 自定义背景颜色
                        color: "#1a1a1a", // 自定义文字颜色
                        textTransform: "none",
                        boxShadow: "none",
                        border: "1px solid #E0E1E5",
                        "&:hover": {
                            backgroundColor: "#efefef", // 悬停时的背景颜色
                        },
                        ...btnSx
                    }}
                >
                    {buttonText}
                </Button>
            </div>
        </div>
    )
}

export default RefreshErrorPage;